import { Capacitor } from "@capacitor/core";
import { isNativePlatform } from "./apputil";
import { isIOS } from "react-device-detect";

export function checkMobile() {
  try {
    const mediaQueryList = window.matchMedia(process.env.NEXT_PUBLIC_MOBILE_QUERY ?? "").matches;
    return mediaQueryList;
  } catch {
    return undefined;
  }
}
export function isInViewport(el: HTMLElement) {
  const rect = el.getBoundingClientRect();

  var isinview =
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth);

  // returns true or false based on whether or not the element is in viewport
  return isinview;
}

const keys: Record<string, boolean> = {
  ArrowLeft: true,
  ArrowUp: true,
  ArrowRight: true,
  ArrowDown: true,
};

function preventDefault(event: Event): void {
  event.preventDefault();
}

function preventDefaultForScrollKeys(event: KeyboardEvent): boolean {
  if (keys[event.key]) {
    preventDefault(event);
    return false;
  }
  return true;
}

let supportsPassive = false;
try {
  window.addEventListener(
    "test",
    () => {},
    Object.defineProperty({}, "passive", {
      get: function () {
        supportsPassive = true;
      },
    }),
  );
} catch (e) {}

const wheelOpt: AddEventListenerOptions | boolean = supportsPassive ? { passive: false } : false;
const wheelEvent = supportsPassive && "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

// Disable scrolling
export function disableScroll(): void {
  // if (isIOS) {
  //   document.body.style.overflow = "hidden";
  //   document.body.style.position = "fixed"; // iOS safari 대응
  //   document.body.style.width = "100%";
  // }
  if (isNativePlatform) {
    document.body.addEventListener("DOMMouseScroll", preventDefault, false); // Older Firefox
    document.body.addEventListener(wheelEvent, preventDefault, wheelOpt); // Modern browsers
  }
  document.body.addEventListener("touchmove", preventDefault, wheelOpt); // Mobile
}

// Enable scrolling
export function enableScroll(mobile?: boolean): void {
  // if (isIOS) {
  //   document.body.style.overflow = "";
  //   document.body.style.position = "";
  //   document.body.style.width = "";
  // }
  if (isNativePlatform) {
    document.body.removeEventListener("DOMMouseScroll", preventDefault, false);
    document.body.removeEventListener(wheelEvent, preventDefault, wheelOpt);
  }
  document.body.removeEventListener("touchmove", preventDefault, wheelOpt);
}
